module.exports = __webpack_public_path__ + "media/images/fallback_audio-51cbdbbd653c8e3b3668f71dbf6e6efc.png";